/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'reload': {
    width: 31,
    height: 31,
    viewBox: '0 0 31 31',
    data: '<g _fill="#00D4FF" fill-rule="evenodd"><circle pid="0" fill-opacity=".097" cx="15.5" cy="15.5" r="15.5"/><path pid="1" d="M22.25 20.9c.45 0 .75.3.75.75s-.3.75-.75.75h-3.975c-.45 0-.75-.3-.75-.75v-3.975c0-.45.3-.75.75-.75s.75.3.75.75V20.3c1.575-1.05 2.475-2.85 2.475-4.8 0-3.3-2.7-6-6-6-.45 0-.75-.3-.75-.75s.3-.75.75-.75c4.125 0 7.5 3.375 7.5 7.5 0 2.1-.9 3.975-2.325 5.4h1.575zm-6.75.6c.45 0 .75.3.75.75s-.3.75-.75.75C11.375 23 8 19.625 8 15.5c0-2.1.825-3.975 2.325-5.4H8.75c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h3.975c.45 0 .75.3.75.75v3.975c0 .45-.3.75-.75.75s-.75-.3-.75-.75V10.7C10.4 11.75 9.5 13.55 9.5 15.5c0 3.3 2.7 6 6 6z"/></g>'
  }
})
